const comms = {
  title: "Communication",
  allChannels: "All",
  notes: "Notes",
  noMessages: "No messages",
  loadMore: "Load more",
  pin: "Pin",
  unpin: "Unpin",
  composePlaceholder: "Write a message...",
  templates: "Templates",
  send: "Send",
  openPanel: "Open communication",
  inbound: "Inbound",
  outbound: "Outbound",
  internal: "Internal",
  pageTitle: "Communication",
  pageDescription: "All messages, calls and conversations in one place",
  search: "Search messages...",
  filterChannel: "Channel",
  filterDirection: "Direction",
  filterRead: "Read",
  filterDate: "Date",
  all: "All",
  read: "Read",
  unread: "Unread",
  sender: "Sender",
  phone: "Phone",
  content: "Content",
  date: "Date",
  channel: "Channel",
  whatsapp: "WhatsApp",
  email: "Email",
  reminder: "Reminder",
  addCall: "Add Call",
  addCallTitle: "Add New Call",
  phoneName: "Phone / Name",
  direction: "Direction",
  summary: "Summary",
  dateTime: "Date & Time",
  save: "Save",
  cancel: "Cancel",
  unreadCount: "Unread",
  sortBy: "Sort by",
  tabCalls: "Calls",
  tabMessages: "Messages",
  tabContacts: "Contacts",
  tabDocs: "Docs",
  tabEmails: "Emails",
  tabNotifications: "Notifications",
  showLabel: "Show:",
  comingSoonTab: "Coming soon — not connected yet",
  sectionContacts: "Contacts",
  sectionTimeline: "Timeline",
  sectionEmails: "Emails",
  sectionNotifications: "Notifications",
  noEmails: "No emails sent",
  noNotifications: "No notifications",
  thinking: "Thinking...",
  timeNow: "now",
  timeYesterday: "yesterday",
  missedCall: "Missed",
  noteLabel: "Note",
  messagesCount: "msgs",
  statusSent: "Sent",
  statusFailed: "Failed",
} as const;
export default comms;
